import {Controller} from "stimulus"
import {validateFields, formSubmittable} from "../../../lib/assets/form-validation"

export default class extends Controller {
    static targets = ["frame", "select", "status"]

    loadFields(event) {
        if (this.submitting) return

        const medium = event.target.value
        this.frameTarget.setAttribute("src", `/interaction/touch_points/medium_fields?medium=${medium}`)
    }

    // Inert once the save is away. formSubmittable recomputes the button's
    // disabled state from the submittable flag, so a field touched while the
    // browser waits would otherwise hand back a live-looking button still
    // labelled Saving... -- the very click with no feedback this lock exists
    // to stop. The selects themselves are left enabled: they carry the medium
    // type and external party, and a disabled control posts no value.
    validate() {
        if (this.submitting) return

        validateFields(this.element.closest('.touch-point-form'))
        formSubmittable(this.element.closest('.touch-point-form'))

    }

    // The form posts with Turbo off, so the popup stays on screen with Save
    // live until the redirect lands. Without this the user, given no sign the
    // first click was taken, clicks again and records the interaction again.
    lockSubmit(event) {
        if (this.submitting) {
            event.preventDefault()
            return
        }

        this.submitting = true
        // Next tick: a submit button disabled from inside its own submit
        // handler is left out of the parameters the browser posts.
        setTimeout(() => this.reportSaving(), 0)
    }

    reportSaving() {
        this.saveButtons.forEach(button => {
            button.disabled = true
            button.value = "Saving..."
        })

        if (this.hasStatusTarget) {
            this.statusTarget.textContent = "Saving your interaction..."
        }
    }

    get saveButtons() {
        return Array.from(this.element.querySelectorAll(".validatable-button"))
    }
}
